import { apiCall } from './gqlClient';
const GETRESOURCES_QUERY = "\n  query getResources($providerId: Int, $archivedAsWell: Boolean) {\n    getResources(providerId: $providerId, archivedAsWell: $archivedAsWell)\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getResourcesApiCall = async function (_ref) {
  let {
    providerId,
    archivedAsWell
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESOURCES_QUERY,
    variables: {
      providerId,
      archivedAsWell
    },
    fragments
  });
};
const GETPHYSICALRESOURCES_QUERY = "\n  query getPhysicalResources($providerId: Int) {\n    getPhysicalResources(providerId: $providerId)\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getPhysicalResourcesApiCall = async function (_ref2) {
  let {
    providerId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPHYSICALRESOURCES_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETALLEVENTSBYRESOURCE_QUERY = "\n  query getAllEventsByResource($id: Int!) {\n    getAllEventsByResource(id: $id)\n    {\n      id\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n      ...fragments\n    }\n  }";
export const getAllEventsByResourceApiCall = async function (_ref3) {
  let {
    id
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLEVENTSBYRESOURCE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETALLNOTASSIGNEDRESOURCESONPROVIDER_QUERY = "\n  query getAllNotAssignedResourcesOnProvider {\n    getAllNotAssignedResourcesOnProvider\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getAllNotAssignedResourcesOnProviderApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLNOTASSIGNEDRESOURCESONPROVIDER_QUERY,
    variables: {},
    fragments
  });
};
const GETRESOURCEAVAILABILITYDATES_QUERY = "\n  query getResourceAvailabilityDates($resourceId: Int!, $subServiceId: Int!, $materialResourceId: Int) {\n    getResourceAvailabilityDates(resourceId: $resourceId, subServiceId: $subServiceId, materialResourceId: $materialResourceId)\n    {\n      availableDays\n\t\t\tminDate\n\t\t\tmaxDate\n      ...fragments\n    }\n  }";
export const getResourceAvailabilityDatesApiCall = async function (_ref4) {
  let {
    resourceId,
    subServiceId,
    materialResourceId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESOURCEAVAILABILITYDATES_QUERY,
    variables: {
      resourceId,
      subServiceId,
      materialResourceId
    },
    fragments
  });
};
const GETRESOURCEAVAILABILITYSLOTS_QUERY = "\n  query getResourceAvailabilitySlots($resourceId: Int!, $subServiceId: Int!, $date: DateTime!, $duration: Int, $reservationId: Int, $isItDeal: Boolean, $materialResource: Int) {\n    getResourceAvailabilitySlots(resourceId: $resourceId, subServiceId: $subServiceId, date: $date, duration: $duration, reservationId: $reservationId, isItDeal: $isItDeal, materialResource: $materialResource)\n  }";
export const getResourceAvailabilitySlotsApiCall = async _ref5 => {
  let {
    resourceId,
    subServiceId,
    date,
    duration,
    reservationId,
    isItDeal,
    materialResource
  } = _ref5;
  return apiCall({
    query: GETRESOURCEAVAILABILITYSLOTS_QUERY,
    variables: {
      resourceId,
      subServiceId,
      date,
      duration,
      reservationId,
      isItDeal,
      materialResource
    }
  });
};
const GETRESOURCESBYSUBSERVICE_QUERY = "\n  query getResourcesBySubService($subServiceId: Int!) {\n    getResourcesBySubService(subServiceId: $subServiceId)\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getResourcesBySubServiceApiCall = async function (_ref6) {
  let {
    subServiceId
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESOURCESBYSUBSERVICE_QUERY,
    variables: {
      subServiceId
    },
    fragments
  });
};
const GETRESOURCESBYSERVICE_QUERY = "\n  query getResourcesByService($serviceId: Int!) {\n    getResourcesByService(serviceId: $serviceId)\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getResourcesByServiceApiCall = async function (_ref7) {
  let {
    serviceId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETRESOURCESBYSERVICE_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETOWNERRESOURCES_QUERY = "\n  query getOwnerResources {\n    getOwnerResources\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getOwnerResourcesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETOWNERRESOURCES_QUERY,
    variables: {},
    fragments
  });
};
const GETCOLLABORATORS_QUERY = "\n  query getCollaborators {\n    getCollaborators\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n      ...fragments\n    }\n  }";
export const getCollaboratorsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETCOLLABORATORS_QUERY,
    variables: {},
    fragments
  });
};
const GETALLARCHIVEDRESOURCES_QUERY = "\n  query getAllArchivedResources {\n    getAllArchivedResources\n    {\n      id\n\t\t\tresTypeId\n\t\t\tuserId\n\t\t\tname\n\t\t\tgender\n\t\t\tproviders\n\t\t\trole\n\t\t\tquantity\n\t\t\tcapacity\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getAllArchivedResourcesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLARCHIVEDRESOURCES_QUERY,
    variables: {},
    fragments
  });
};
const GETSUBSERVICESCLASSESBYRESOURCE_QUERY = "\n  query getSubservicesClassesByResource($resourceId: Int!) {\n    getSubservicesClassesByResource(resourceId: $resourceId)\n  }";
export const getSubservicesClassesByResourceApiCall = async _ref8 => {
  let {
    resourceId
  } = _ref8;
  return apiCall({
    query: GETSUBSERVICESCLASSESBYRESOURCE_QUERY,
    variables: {
      resourceId
    }
  });
};
const GETINDIVIDUALCOLLABORATORPERCENT_QUERY = "\n  query getIndividualCollaboratorPercent($resourceId: Int!) {\n    getIndividualCollaboratorPercent(resourceId: $resourceId)\n  }";
export const getIndividualCollaboratorPercentApiCall = async _ref9 => {
  let {
    resourceId
  } = _ref9;
  return apiCall({
    query: GETINDIVIDUALCOLLABORATORPERCENT_QUERY,
    variables: {
      resourceId
    }
  });
};
const EDITRESOURCE_QUERY = "\n  mutation editResource($id: Int!, $name: String!, $gender: String, $role: String, $userId: Int, $capacity: Int) {\n    editResource(id: $id, name: $name, gender: $gender, role: $role, userId: $userId, capacity: $capacity)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const editResourceApiCall = async function (_ref10) {
  let {
    id,
    name,
    gender,
    role,
    userId,
    capacity
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: EDITRESOURCE_QUERY,
    variables: {
      id,
      name,
      gender,
      role,
      userId,
      capacity
    },
    fragments
  });
};
const ARCHIVERESOURCE_QUERY = "\n  mutation archiveResource($id: Int!) {\n    archiveResource(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveResourceApiCall = async function (_ref11) {
  let {
    id
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVERESOURCE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const ARCHIVEWITHREASIGNRESOURCE_QUERY = "\n  mutation archiveWithReasignResource($id: Int!, $resourceId: Int!, $past: Boolean!, $future: Boolean!) {\n    archiveWithReasignResource(id: $id, resourceId: $resourceId, past: $past, future: $future)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveWithReasignResourceApiCall = async function (_ref12) {
  let {
    id,
    resourceId,
    past,
    future
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEWITHREASIGNRESOURCE_QUERY,
    variables: {
      id,
      resourceId,
      past,
      future
    },
    fragments
  });
};
const ARCHIVEWITHREASIGNRESOURCETOOWNER_QUERY = "\n  mutation archiveWithReasignResourceToOwner($id: Int!) {\n    archiveWithReasignResourceToOwner(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveWithReasignResourceToOwnerApiCall = async function (_ref13) {
  let {
    id
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEWITHREASIGNRESOURCETOOWNER_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CREATERESOURCE_QUERY = "\n  mutation createResource($request: ResourceCreateInput) {\n    createResource(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createResourceApiCall = async function (_ref14) {
  let {
    request
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATERESOURCE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const RESTOREARCHIVEDRESOURCE_QUERY = "\n  mutation restoreArchivedResource($id: Int!) {\n    restoreArchivedResource(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreArchivedResourceApiCall = async function (_ref15) {
  let {
    id
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTOREARCHIVEDRESOURCE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const SAVEINDIVIDUALCOLLABORATORPERCENT_QUERY = "\n  mutation saveIndividualCollaboratorPercent($request: IndividualCollaboratorPercentInput!) {\n    saveIndividualCollaboratorPercent(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const saveIndividualCollaboratorPercentApiCall = async function (_ref16) {
  let {
    request
  } = _ref16;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEINDIVIDUALCOLLABORATORPERCENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEINDIVIDUALCOLLABORATORPERCENT_QUERY = "\n  mutation updateIndividualCollaboratorPercent($id: String!, $amountType: String!, $amount: Float!) {\n    updateIndividualCollaboratorPercent(id: $id, amountType: $amountType, amount: $amount)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateIndividualCollaboratorPercentApiCall = async function (_ref17) {
  let {
    id,
    amountType,
    amount
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEINDIVIDUALCOLLABORATORPERCENT_QUERY,
    variables: {
      id,
      amountType,
      amount
    },
    fragments
  });
};
const DELETEINDIVIDUALCOLLABORATORPERCENT_QUERY = "\n  mutation deleteIndividualCollaboratorPercent($id: String!) {\n    deleteIndividualCollaboratorPercent(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteIndividualCollaboratorPercentApiCall = async function (_ref18) {
  let {
    id
  } = _ref18;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEINDIVIDUALCOLLABORATORPERCENT_QUERY,
    variables: {
      id
    },
    fragments
  });
};